import { FormControlProps } from '../../interfaces/FormControlProps';
import { FormFieldStateHelpers } from './FormFieldStateHelpers';

export class FormStylingHelpers {
    static getFormGroupStyle(props: FormControlProps) {
        let additionalCssClass = '';
        if (props.formFieldDefinition.cssClass !== undefined) {
            additionalCssClass = props.formFieldDefinition.cssClass;
        }
        if (props.formFieldDefinition.fieldCssClass !== undefined) {
            additionalCssClass += " " + props.formFieldDefinition.fieldCssClass;
        }
        return 'form-group' + props.visibilityClass + ' ' + additionalCssClass;
    }

    static getInputStyle(component: React.Component<FormControlProps>) {
        const props = component.props;
        const { isTouchedOnlyWhenRequired } = FormFieldStateHelpers.getFieldState(component);

        const hasErrors = FormFieldStateHelpers.hasErrors(component);

        return FormFieldStateHelpers.isTouchedHasErrors(component)
            ? 'is-invalid form-control'
            : isTouchedOnlyWhenRequired && !hasErrors
            ? 'form-control--touched form-control'
            : 'form-control';
    }

    static getDropdownStyle(component: React.Component<FormControlProps>) {
        const props = component.props;
        return FormFieldStateHelpers.isTouchedHasErrors(component)
            ? 'form-control is-invalid form-dropdown__container'
            : 'form-control form-dropdown__container';
    }

    static getCheckboxStyle(component: React.Component<FormControlProps>) {
        const props = component.props;
        return FormFieldStateHelpers.isTouchedHasErrors(component)
            ? 'is-invalid custom-control-input'
            : 'custom-control-input';
    }

    static getRadioStyle(component: React.Component<FormControlProps>) {
        return this.getCheckboxStyle(component);
    }
}
